{
  "validation_error": "Enter a snippet name",
  "toggle_button_text": "Create a snippet",
  "header": "Create a snippet",
  "label": "Snippet name",
  "view_button": "View snippet",
  "create_error": "Error creating snippet",
  "cancel_button": "Cancel",
  "placeholder": "Try \"Auditions\"",
  "help": {
    "title": "✨ What's this?",
    "text": "Think of a snippet as a mini schedule. You can create a filtered version of your schedule for you, or to share with others!"
  }
}
